import e from 'express';
import { CourseType } from '../api/utils/lms/ExtendSetBtnLink';

const home = {
  img: '/svg/icon/classHome-gray.svg',
  imgActive: '/svg/icon/classHome-purple.svg',
  title: '클래스 홈',
  path: `./dashboard`,
};
const takeClass = {
  img: '/svg/icon/manageClass-gray.svg',
  imgActive: '/svg/icon/manageClass-purple.svg',
  title: '수업자료 보기',
  path: `./take-class`,
};
const studentMgmt = {
  img: '/svg/icon/manageStudent-gray.svg',
  imgActive: '/svg/icon/manageStudent-purple.svg',
  title: '학생 관리',
  path: `./signup-management`,
};
const recitationTodo = {
  img: '/svg/icon/note-gray.svg',
  imgActive: '/svg/icon/note-purple.svg',
  title: '(구)인증제 관리',
  path: `./todo-management/recitation`,
};
const jebsAiRecitationMgmt = {
  img: '/svg/icon/note-gray.svg',
  imgActive: '/svg/icon/note-purple.svg',
  title: 'AI 인증제',
  path: `./todo-management/jebs_ai_recitation`,
};
const JebspleMgmt = {
  img: '/svg/icon/todo-gray.svg',
  imgActive: '/svg/icon/todo-purple.svg',
  title: '젭스플 관리',
  path: `./todo-management/jebspl`,
};
const JebsonMgmt = {
  img: '/svg/icon/todo-gray.svg',
  imgActive: '/svg/icon/todo-purple.svg',
  title: '젭스온 관리',
  path: `./todo-management/jebson`,
};
const classSetting = {
  img: '/svg/icon/plus-gray.svg',
  imgActive: '/svg/icon/plus-purple.svg',
  title: '클래스설정',
  path: `./class-setting`,
};
const noticeMgmt = {
  img: '/svg/footer/jebtalk.svg',
  title: 'TALK',
  path: `./notice-management`,
};

const assignmentMgmt = {
  img: '/svg/icon/todo-gray.svg',
  imgActive: '/svg/icon/todo-purple.svg',
  title: '과제',
  path: `./assignment`,
};
const recitationMgmt = {
  img: '/svg/icon/note-gray.svg',
  imgActive: '/svg/icon/note-purple.svg',
  title: 'AI인증제',
  path: `./recitation`,
};

export const NavigationList = (classId: string, subType: CourseType) => {
  if (subType === 'HOME') {
    return [home, takeClass, assignmentMgmt, recitationMgmt, studentMgmt];
  } else if (subType === 'CHURCH') {
    return [home, takeClass, assignmentMgmt, studentMgmt];
  } else {
    return [home, takeClass, studentMgmt];
  }
};
